"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFormFactory = void 0;
const core_api_1 = require("@ikegps/core-api");
const __1 = require("..");
const PoleDimensions_1 = require("./AnsiO5.1/PoleDimensions");
const BaseForm_1 = require("./BaseForm");
const unit_1 = require("../../unit");
class BaseFormFactory {
    constructor(form, hasVerticalSeparationToken = false) {
        this.form = form;
        this.hasVerticalSeparationToken = hasVerticalSeparationToken;
    }
    get baseForm() {
        return new BaseForm_1.BaseForm(this.form);
    }
    rootPoleSubForm() {
        this.form.Mutator.poleType();
    }
    addBaseFormFields() {
        this.addStatusField();
        this.addSequenceField();
        this.addIdField();
        this.addTagPhotosField();
        this.addTypeField();
        this.addOwnerField(this.form, __1.PoleFieldIds.POLE_OWNER);
        this.addCircumferenceField();
        this.addTipField();
        this.addLowPowerAttachmentField();
        this.addLocationField();
        this.addStreetAddressField();
        this.addNoteField(this.form, __1.PoleFieldIds.NOTE);
        this.addIkePhotoField();
        this.addLowPowerToCommField();
        this.addEquipmentField();
        this.addAnchorSubform();
        this.addSpanField();
        this.addMakeReadyField();
    }
    addStatusField() {
        const statusField = this.form.createField(core_api_1.IkeFieldType.NESTED_LIST, {
            id: __1.PoleFieldIds.STATUS,
            displayName: 'Status',
        });
        const builder = statusField.Mutator.builder;
        const optionGroup = builder.createGroup('Status');
        optionGroup.createValue('Field QC', undefined, '#024092');
        optionGroup.createValue('Field Recollect', undefined, '#f31233');
        optionGroup.createValue('HOA', undefined, '#66aee5');
        optionGroup.createValue('Field Recollect Precheck', undefined, '#b373e8');
        optionGroup.createValue('HOA QC', undefined, '#a3c4ef');
        optionGroup.createValue('HOA QC Rework', undefined, '#d92020');
        optionGroup.createValue('MRE', undefined, '#40f7f4');
        optionGroup.createValue('Final QC', undefined, '#21c4a9');
        optionGroup.createValue('Final QC Rework', undefined, '#ce542c');
        optionGroup.createValue('Delivery', undefined, '#0ff035');
        optionGroup.createValue('Billing', undefined, '#088c0a');
        optionGroup.createValue('Done', undefined, '#12800a');
        statusField.Mutator.init(builder.options);
        this.form.metadata.setStatusField(statusField);
        this.form.metadata.setMapColorField(statusField);
    }
    addSequenceField() {
        this.form.createField(core_api_1.IkeFieldType.TEXT, {
            id: __1.PoleFieldIds.SEQUENCE,
            displayName: 'Sequence',
        });
    }
    addIdField() {
        this.form.createField(core_api_1.IkeFieldType.TEXT, {
            id: __1.PoleFieldIds.POLE_ID,
            displayName: 'Id',
            title: true,
            locked: true,
        });
        this.form.Mutator.label([__1.PoleFieldIds.POLE_ID]);
    }
    addTagPhotosField() {
        this.form.createField(core_api_1.IkeFieldType.IMAGE, {
            id: __1.PoleFieldIds.IMAGES,
            displayName: 'Tag Photos',
            locked: true,
        });
    }
    addTypeField() {
        const typeField = this.form.createField(core_api_1.IkeFieldType.NESTED_LIST, {
            id: __1.PoleFieldIds.POLE_TYPE,
            cloneable: core_api_1.IkeCloneable.ALL,
            displayName: 'Type',
            locked: false,
        });
        const builder = typeField.Mutator.builder;
        const speciesGroup = builder.createGroup('Species');
        this.addSpeciesOptionWithClassAndHeights(speciesGroup, 'Wood', true);
        this.addSpeciesOptionWithClassAndHeights(speciesGroup, 'Steel', true);
        this.addSpeciesOptionWithClassAndHeights(speciesGroup, 'Fiberglass', false);
        this.addSpeciesOptionWithClassAndHeights(speciesGroup, 'Concrete', false);
        this.addSpeciesOptionWithClassAndHeights(speciesGroup, 'Other', true);
        typeField.Mutator.init(builder.options);
    }
    addSpeciesOptionWithClassAndHeights(speciesGroup, name, includeHPoleClasses) {
        const option = speciesGroup.createValue(name);
        this.addClassOptions(option, includeHPoleClasses ? [...(0, PoleDimensions_1.normalClasses)(), ...(0, PoleDimensions_1.hClasses)()] : (0, PoleDimensions_1.normalClasses)());
    }
    addClassOptions(option, poleClasses) {
        const group = option.createGroup('Class of Pole');
        for (const poleClass of poleClasses) {
            const classOption = group.createValue(poleClass);
            this.addHeightOptions(classOption, poleClass);
        }
    }
    addHeightOptions(value, poleClass) {
        const group = value.createGroup('Height');
        for (const height of (0, PoleDimensions_1.poleLengthsForClass)(poleClass)) {
            group.createValue(`${height}`);
        }
    }
    addOwnerField(parent, id) {
        const ownerField = parent.createField(core_api_1.IkeFieldType.NESTED_LIST, {
            id,
            cloneable: core_api_1.IkeCloneable.ALL,
            displayName: 'Owner',
            locked: false,
        });
        const builder = ownerField.Mutator.builder;
        const industryGroup = builder.createGroup('Industry');
        const utilityOption = industryGroup.createValue('UTILITY');
        const utilityOwnerIdGroup = utilityOption.createGroup('Owner Id');
        utilityOwnerIdGroup.createValue('Power');
        const communicationOption = industryGroup.createValue('COMMUNICATION');
        const communicationOwnerIdGroup = communicationOption.createGroup('Owner Id');
        communicationOwnerIdGroup.createValue('CATV');
        communicationOwnerIdGroup.createValue('Telco');
        communicationOwnerIdGroup.createValue('Fiber');
        communicationOwnerIdGroup.createValue('Unknown');
        ownerField.Mutator.init(builder.options);
    }
    addCircumferenceField() {
        this.form.createField(core_api_1.IkeFieldType.NUMBER, {
            id: __1.PoleFieldIds.CIRCUMFERENCE,
            displayName: 'Circumference (")',
            locked: true,
        });
    }
    addTipField() {
        this.form.createField(core_api_1.IkeFieldType.HEIGHT, {
            id: __1.PoleFieldIds.AGL,
            displayName: 'Tip',
            collector: core_api_1.IkeCollectorType.OFFICE,
            locked: true,
        });
    }
    addLowPowerAttachmentField() {
        this.form.createField(core_api_1.IkeFieldType.HEIGHT, {
            id: __1.PoleFieldIds.LOW_POWER_ATTACHMENT,
            displayName: 'Low Power Attachment',
            collector: core_api_1.IkeCollectorType.OFFICE,
        });
    }
    addLocationField() {
        this.form.createField(core_api_1.IkeFieldType.LOCATION, {
            id: __1.PoleFieldIds.GEOGRAPHIC_COORDINATE,
            displayName: 'Location',
            locked: true,
        });
    }
    addStreetAddressField() {
        const addressField = this.form.createField(core_api_1.IkeFieldType.TEXT, {
            id: __1.PoleFieldIds.STREET_ADDRESS,
            displayName: 'Street Address',
            collector: core_api_1.IkeCollectorType.OFFICE,
        });
        this.form.metadata.setAddressLookupField(addressField);
    }
    addNoteField(parent, id, displayName = 'Note') {
        parent.createField(core_api_1.IkeFieldType.TEXT, {
            id,
            displayName,
            locked: false,
        });
    }
    addIkePhotoField() {
        this.form.createField(core_api_1.IkeFieldType.TRUE_SIZE, {
            id: __1.PoleFieldIds.IKE_PHOTO,
            displayName: 'IKE Photo',
            collector: core_api_1.IkeCollectorType.ALL,
            required: true,
            locked: true,
        });
    }
    addLowPowerToCommField() {
        this.form.createField(core_api_1.IkeFieldType.VERTICAL_SEPARATION, Object.assign(Object.assign({ id: __1.PoleFieldIds.LOW_POWER_TO_COMM, displayName: 'Low Power to Comm', annotationLabelFieldId: __1.PoleFieldIds.LOW_POWER_TO_COMM }, (this.hasVerticalSeparationToken && {
            clearanceThresholdInMeters: unit_1.IkeUnit.round(unit_1.IkeUnit.convert(40, unit_1.IkeUnit.METER, unit_1.IkeUnit.INCH), 3),
        })), { collector: core_api_1.IkeCollectorType.OFFICE }));
    }
    addEquipmentField() {
        const equipmentField = this.form.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.EQUIPMENT.FORM,
            displayName: 'Equipment',
            locked: true,
        });
        this.addEquipmentTypeField(equipmentField);
        this.addEquipmentOrientationField(equipmentField);
        this.addOwnerField(equipmentField, __1.PoleFieldIds.EQUIPMENT.OWNER);
        this.addAttachmentHeightField(equipmentField, __1.PoleFieldIds.EQUIPMENT.ATTACHMENT_HEIGHT, true);
        this.addEquipmentBottomHeightField(equipmentField);
        this.addNoteField(equipmentField, __1.PoleFieldIds.EQUIPMENT.NOTE);
    }
    addEquipmentTypeField(equipmentField) {
        const equipmentTypeField = equipmentField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.EQUIPMENT.TYPE,
            displayName: 'Type',
            title: true,
            locked: false,
        });
        equipmentTypeField.Mutator.option({ text: 'Capacitor Bank', value: '1' });
        equipmentTypeField.Mutator.option({ text: 'Crossarm', value: '2' });
        equipmentTypeField.Mutator.option({ text: 'Recloser', value: '3' });
        equipmentTypeField.Mutator.option({ text: 'Regulator', value: '4' });
        equipmentTypeField.Mutator.option({ text: 'Riser', value: '5' });
        equipmentTypeField.Mutator.option({ text: 'Streetlight', value: '6' });
        equipmentTypeField.Mutator.option({ text: 'Transformer - Single Phase', value: '7' });
        equipmentTypeField.Mutator.option({ text: 'Transformer - Three Phase', value: '8' });
        equipmentTypeField.Mutator.option({ text: 'Switch', value: '9' });
    }
    addEquipmentOrientationField(equipmentField) {
        equipmentField.createField(core_api_1.IkeFieldType.NUMBER, {
            id: __1.PoleFieldIds.EQUIPMENT.ORIENTATION,
            displayName: 'Orientation',
            locked: true,
        });
    }
    addEquipmentBottomHeightField(equipmentField) {
        equipmentField.createField(core_api_1.IkeFieldType.HEIGHT, {
            id: __1.PoleFieldIds.EQUIPMENT.ATTACHMENT_BOTTOM_HEIGHT,
            displayName: 'Bottom Height',
            collector: core_api_1.IkeCollectorType.OFFICE,
            locked: true,
        });
    }
    addAttachmentHeightField(parentField, id, locked) {
        parentField.createField(core_api_1.IkeFieldType.HEIGHT, {
            id,
            displayName: 'Attachment Height',
            collector: core_api_1.IkeCollectorType.OFFICE,
            locked,
        });
    }
    addAnchorSubform() {
        const anchorField = this.form.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.ANCHOR.FORM,
            displayName: 'Anchor',
            locked: true,
        });
        this.addAnchorField(anchorField);
        this.addOwnerField(anchorField, __1.PoleFieldIds.ANCHOR.OWNER);
        this.addNoteField(anchorField, __1.PoleFieldIds.ANCHOR.NOTE);
        this.addAnchorGuyField(anchorField);
    }
    addAnchorField(anchorField) {
        anchorField.createField(core_api_1.IkeFieldType.ANCHOR, {
            id: __1.PoleFieldIds.ANCHOR.LENGTH,
            displayName: 'Lead Length',
            locked: true,
        });
    }
    addAnchorGuyField(anchorField) {
        const anchorGuyField = anchorField.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.ANCHOR.GUY.FORM,
            displayName: 'Guys',
            locked: true,
        });
        this.addAnchorGuySizeField(anchorGuyField);
        this.addOwnerField(anchorGuyField, __1.PoleFieldIds.ANCHOR.GUY.OWNER);
        this.addAttachmentHeightField(anchorGuyField, __1.PoleFieldIds.ANCHOR.GUY.ATTACHMENT_HEIGHT, true);
    }
    addAnchorGuySizeField(anchorGuyField) {
        const anchorGuySizeField = anchorGuyField.createField(core_api_1.IkeFieldType.NESTED_LIST, {
            id: __1.PoleFieldIds.ANCHOR.GUY.SIZE,
            displayName: 'Size',
            title: true,
            locked: true,
        });
        const builder = anchorGuySizeField.Mutator.builder;
        const usageGroup = builder.createGroup('Usage Group');
        const downValue = usageGroup.createValue('Down');
        const downValueSizeGroup = downValue.createGroup('Size');
        downValueSizeGroup.createValue('EHS 1/8');
        downValueSizeGroup.createValue('EHS 5/32');
        downValueSizeGroup.createValue('EHS 3/16');
        downValueSizeGroup.createValue('EHS 7/32');
        downValueSizeGroup.createValue('EHS 1/4');
        downValueSizeGroup.createValue('EHS 9/32');
        downValueSizeGroup.createValue('EHS 5/16');
        downValueSizeGroup.createValue('EHS 3/8');
        downValueSizeGroup.createValue('EHS 7/16');
        downValueSizeGroup.createValue('EHS 1/2');
        downValueSizeGroup.createValue('EHS 9/16');
        downValueSizeGroup.createValue('EHS 5/8');
        downValueSizeGroup.createValue('6M');
        downValueSizeGroup.createValue('10M');
        downValueSizeGroup.createValue('12M');
        downValueSizeGroup.createValue('25M');
        anchorGuySizeField.Mutator.init(builder.options);
    }
    addSpanField() {
        const spanField = this.form.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.SPAN.FORM,
            displayName: 'Span',
            cloneable: core_api_1.IkeCloneable.FIRST,
            locked: true,
        });
        this.addSpanLengthField(spanField);
        this.addSpanTypeField(spanField);
        this.addMidSpanPhoto(spanField);
        this.addNoteField(spanField, __1.PoleFieldIds.SPAN.NOTE);
        this.addSpanWireField(spanField);
        spanField.Mutator.span.setFieldReferences(__1.PoleFieldIds.SPAN.LENGTH, __1.PoleFieldIds.SPAN.TYPE, __1.PoleFieldIds.SPAN.MID_SPAN_PHOTO);
    }
    addSpanLengthField(spanField) {
        spanField.createField(core_api_1.IkeFieldType.VECTOR, {
            id: __1.PoleFieldIds.SPAN.LENGTH,
            displayName: 'Span Length',
            locked: true,
        });
    }
    addSpanTypeField(spanField) {
        const spanTypeField = spanField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.SPAN.TYPE,
            displayName: 'Type',
            title: true,
            locked: true,
        });
        spanTypeField.Mutator.option({ text: 'Fore Span', value: __1.SpanType.NextPole });
        spanTypeField.Mutator.option({ text: 'Back Span', value: __1.SpanType.PreviousPole });
        spanTypeField.Mutator.option({ text: 'Other', value: __1.SpanType.Other });
        spanTypeField.Mutator.option({ text: 'Building', value: __1.SpanType.Building });
    }
    addMidSpanPhoto(spanField) {
        spanField.createField(core_api_1.IkeFieldType.TRUE_SIZE, {
            id: __1.PoleFieldIds.SPAN.MID_SPAN_PHOTO,
            displayName: 'Mid Span IKE Photo',
            locked: true,
        });
    }
    addSpanWireField(spanField) {
        const wireField = spanField.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.SPAN.WIRE.FORM,
            displayName: 'Wire',
            cloneable: core_api_1.IkeCloneable.FIRST,
            locked: true,
        });
        this.addWireMidSpanHeightField(wireField);
        this.addWireUsageGroupField(wireField);
        this.addOwnerField(wireField, __1.PoleFieldIds.SPAN.WIRE.OWNER);
        this.addAttachmentHeightField(wireField, __1.PoleFieldIds.SPAN.WIRE.ATTACHMENT_HEIGHT, true);
    }
    addWireMidSpanHeightField(wireField) {
        wireField.createField(core_api_1.IkeFieldType.HEIGHT, {
            id: __1.PoleFieldIds.SPAN.WIRE.MID_SPAN_HEIGHT,
            displayName: 'Mid Span Height',
            locked: true,
        });
    }
    addWireUsageGroupField(wireField) {
        const wireUsageGroupField = wireField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.SPAN.WIRE.USAGE_GROUP,
            displayName: 'Usage Group',
        });
        wireUsageGroupField.Mutator.option({ text: 'Primary', value: 'PRIMARY' });
        wireUsageGroupField.Mutator.option({ text: 'Neutral', value: 'NEUTRAL' });
        wireUsageGroupField.Mutator.option({ text: 'Secondary', value: 'SECONDARY' });
        wireUsageGroupField.Mutator.option({ text: 'Comm Messenger', value: 'COMM_MESSENGER' });
        wireUsageGroupField.Mutator.option({ text: 'CATV', value: 'CATV' });
        wireUsageGroupField.Mutator.option({ text: 'Telco', value: 'TELCO' });
        wireUsageGroupField.Mutator.option({ text: 'Fiber', value: 'FIBER' });
        wireUsageGroupField.Mutator.option({ text: 'Span Guy', value: 'SPAN_GUY' });
    }
    addMakeReadyField() {
        const makeReadyField = this.form.createField(core_api_1.IkeFieldType.FORM, {
            id: __1.PoleFieldIds.MAKE_READY.FORM,
            displayName: 'Make Ready',
            collector: core_api_1.IkeCollectorType.OFFICE,
        });
        this.addMakeReadyAttachmentSizeField(makeReadyField);
        this.addMakeReadyAttachmentTypeField(makeReadyField);
        this.addAttachmentHeightField(makeReadyField, __1.PoleFieldIds.MAKE_READY.ATTACHMENT_HEIGHT, false);
        this.addMakeReadyProposedMidSpanField(makeReadyField);
        this.addMakeReadyProposedRiserField(makeReadyField);
        this.addMakeReadyTypeField(makeReadyField);
        this.addNoteField(makeReadyField, __1.PoleFieldIds.MAKE_READY.NOTE, 'Make Ready Notes');
    }
    addMakeReadyAttachmentSizeField(makeReadyField) {
        makeReadyField.createField(core_api_1.IkeFieldType.TEXT, {
            id: __1.PoleFieldIds.MAKE_READY.ATTACHMENT_SIZE,
            displayName: 'Attachment Size',
            title: true,
        });
    }
    addMakeReadyAttachmentTypeField(makeReadyField) {
        const makeReadyAttachmentTypeField = makeReadyField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.MAKE_READY.ATTACHMENT_TYPE,
            displayName: 'Attachment Type',
        });
        makeReadyAttachmentTypeField.Mutator.option({ text: 'New', value: 'NEW' });
        makeReadyAttachmentTypeField.Mutator.option({ text: 'Overlash', value: 'OVERLASH' });
    }
    addMakeReadyProposedMidSpanField(makeReadyField) {
        makeReadyField.createField(core_api_1.IkeFieldType.HEIGHT, {
            id: __1.PoleFieldIds.MAKE_READY.PROPOSED_MID_SPAN,
            displayName: 'Proposed Mid Span',
        });
    }
    addMakeReadyProposedRiserField(makeReadyField) {
        const makeReadyProposedRiserField = makeReadyField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.MAKE_READY.PROPOSED_RISER,
            displayName: 'Proposed Riser',
            collector: core_api_1.IkeCollectorType.OFFICE,
        });
        makeReadyProposedRiserField.Mutator.option({ text: 'N', value: 'N' });
        makeReadyProposedRiserField.Mutator.option({ text: 'E', value: 'E' });
        makeReadyProposedRiserField.Mutator.option({ text: 'S', value: 'S' });
        makeReadyProposedRiserField.Mutator.option({ text: 'W', value: 'W' });
        makeReadyProposedRiserField.Mutator.option({ text: 'NE', value: 'NE' });
        makeReadyProposedRiserField.Mutator.option({ text: 'NW', value: 'NW' });
        makeReadyProposedRiserField.Mutator.option({ text: 'SE', value: 'SE' });
        makeReadyProposedRiserField.Mutator.option({ text: 'SW', value: 'SW' });
    }
    addMakeReadyTypeField(makeReadyField) {
        const makeReadyTypeField = makeReadyField.createField(core_api_1.IkeFieldType.SELECT_LIST, {
            id: __1.PoleFieldIds.MAKE_READY.TYPE,
            displayName: 'Type',
        });
        makeReadyTypeField.Mutator.option({ text: 'Power', value: 'POWER' });
        makeReadyTypeField.Mutator.option({ text: 'Comm', value: 'COMM' });
        makeReadyTypeField.Mutator.option({ text: 'Other', value: 'OTHER' });
    }
}
exports.BaseFormFactory = BaseFormFactory;
//# sourceMappingURL=BaseFormFactory.js.map